import { store } from '../../../../../../../store';

export const getRecordStatus = hasRecord => {
  const asset = store.getState().asset;

  let recordStatusIcon = '';
  switch (hasRecord?.status) {
    case 'ingested':
      recordStatusIcon = asset?.recording_fullEpg_recorded_icon;
      break;
    case 'recording':
      recordStatusIcon = asset?.recording_fullEpg_recordingBlink_icon;
      break;
    case 'scheduled':
      recordStatusIcon = asset?.recording_fullEpg_toRecord_icon;
      break;
    default:
      recordStatusIcon = '';
      break;
  }
  return {
    recordStatusIcon,
    recordStatus: hasRecord?.status,
  };
};
